// extracted by mini-css-extract-plugin
module.exports = {"footerLocale":"hj","disabled":"ij","iconContainer":"jj","hidden":"kj"};